/** @file GENERATED by pnpm gen; do not edit. */
export const CATALOG_PARTS = [] as const;
